module.exports = __webpack_public_path__ + "img/nong-ch.ef0970a6.gif";